"use client";

import React from "react";
import { PrismicImage, SliceZone } from "@prismicio/react";
import { components } from "@/slices";
import Link from "next/link";


export default function CFooter({ logo, slices, context }) {

  return (
    <footer className="w-full pt-8 pb-10 px-5 md:px-20 md:py-20 theme-dark-pink flex flex-col justify-start items-start gap-10">
      <Link href="/">
        <PrismicImage field={logo} className="w-44" />
      </Link>
      <div className="flex flex-col md:flex-row justify-between items-start gap-16 md:gap-4 w-full">
        <SliceZone slices={slices} components={components} context={context} />
      </div>
    </footer>
  );
}
